var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCovHosting = function SvgCovHosting(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 133.818,
    height: 107.328,
    viewBox: "0 0 133.818 107.328",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-986.95 -882.042)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-.9-.9H132.918V106.428H-.9ZM131.118.9H.9V104.628H131.118Z",
    transform: "translate(987.85 882.942)",
    fill: "#183149"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.031.9H0V-.9H118.031Z",
    transform: "translate(987.85 897.523)",
    fill: "#183149"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.759.9H0V-.9H4.759Z",
    transform: "translate(996.134 890.314)",
    fill: "#5680e9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.759.9H0V-.9H4.759Z",
    transform: "translate(1005.652 890.314)",
    fill: "#5680e9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.759.9H0V-.9H4.759Z",
    transform: "translate(1015.17 890.314)",
    fill: "#5680e9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.759.9H0V-.9H4.759Z",
    transform: "translate(1013.878 951.383)",
    fill: "#5680e9"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1023.573 952.569)",
    fill: "#183149",
    fontSize: 28,
    fontFamily: "BaiJamjuree-Regular, Bai Jamjuree",
    letterSpacing: "0.15em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "COM")))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCovHosting, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cov-hosting.f8654d14.svg";
export { ForwardRef as ReactComponent };